export interface BackofficeUser {
  email: string;
  name: string;
  groups: string[];
  permissions: Record<string, Record<string, boolean>>;
  flags: { is_admin?: boolean; all_pages?: boolean; all_pages_all_options?: boolean };
}

export function can(user: BackofficeUser | null, page: string, action = 'read'): boolean {
  if (!user) return false;
  if (user.flags?.is_admin || user.flags?.all_pages_all_options) return true;
  if (user.flags?.all_pages && action === 'read') return true;
  return Boolean(user.permissions?.[page]?.[action]);
}
